Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tweet = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
var _utils = require("./utils");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Tweet = function Tweet(_ref) {
  var tweetLink = _ref.tweetLink,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align,
    _ref$hideConversation = _ref.hideConversation,
    hideConversation = _ref$hideConversation === void 0 ? false : _ref$hideConversation;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleTwttrLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "twitter-tweet",
    className: "twitter-tweet-mdx-embed",
    style: {
      overflow: 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement("blockquote", {
    className: "twitter-tweet",
    "data-theme": theme,
    "data-align": align,
    "data-conversation": hideConversation ? 'none' : ''
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://twitter.com/".concat(tweetLink, "?ref_src=twsrc%5Etfw")
  }, typeof window !== 'undefined' && !window.twttr ? 'Loading' : ''))));
};
exports.Tweet = Tweet;